<div class="container" id="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Zusatzfunktionen bearbeiten </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="editForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Funktionsname:</mat-label>
                                <input matInput type="text" formControlName="optionName">
                                <mat-error *ngIf="editForm.get('optionName').hasError('required')">
                                    Funktionsname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Angezeigter Name:</mat-label>
                                <input matInput type="text" formControlName="displayName">
                                <mat-error *ngIf="editForm.get('displayName').hasError('required')">
                                    Angezeigter Name <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Beschreibung:</mat-label>
                                <input matInput type="text" formControlName="description">
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row ">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Status</mat-label>
                                <mat-select formControlName="state">
                                    <mat-option *ngFor="let state of states" [value]="state.value"
                                        [disabled]="state.state">
                                        {{state.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Status <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>                   
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                    <button mat-button color="primary" (click)="editAccountOptions()">Änderungen Speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>